import axios from 'axios'

export const paidQuoteDetails = ({ quoteId }) => {
    return axios({
        method: 'get',
        url: '/payments/quote/details',
        params: { uid: quoteId }
    })
}
